import React from 'react';
import { Link } from 'react-router-dom';
import { FiArrowLeft } from 'react-icons/fi';
import VoicesInteriorScene from '../voices/VoicesInteriorScene';

export default function BlogBanner({ story }) {
  return <section className="blogBanner voices-story-banner" aria-labelledby="voices-story-title">
    <VoicesInteriorScene className="voices-story-hero" scene="pair">
      <nav className="voices-story-breadcrumb" aria-label="Customer stories">
        <Link to="/work"><FiArrowLeft aria-hidden="true" />All customer stories</Link>
      </nav>
      <div className="voices-story-brand">
        {story.Brandlogo ? <img src={story.Brandlogo} alt={story.customer} /> : <p>{story.customer}</p>}
      </div>
      <h1 id="voices-story-title" className="blogBannerTitle" dangerouslySetInnerHTML={{ __html: story.detailPageHeadline || '' }} />
    </VoicesInteriorScene>
    <div className="blogBannerImageWrapper">
      <img src={story.backgroundImage} alt={`${story.customer} customer story`} className="blogBannerImage" fetchpriority="high" />
    </div>
  </section>;
}
